import { render } from "./LoyverseOrders.vue?vue&type=template&id=3f67ce0d&scoped=true"
import script from "./LoyverseOrders.vue?vue&type=script&lang=js"
export * from "./LoyverseOrders.vue?vue&type=script&lang=js"

import "./LoyverseOrders.vue?vue&type=style&index=0&id=3f67ce0d&scoped=true&lang=css"
import "./LoyverseOrders.vue?vue&type=style&index=1&id=3f67ce0d&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f67ce0d"]])

export default __exports__